<template>
  <div
    class="block-ui d-flex align-center justify-center"
    id="app--block-ui"
  >
    <div class="loading-spinner d-flex flex-column align-center justify-center">
      <v-progress-circular
        :size="size"
        :width="width"
        :color="colour"
        indeterminate
        aria-label="loading"
      />
      <div class="mt-4 block-ui--loading-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BlockUI",
    props: {
      size: {
          type: String,
          default: "70"
      },
      width: {
          type: String,
          default: "6"
      },
      colour: {
          type: String,
          default: "primary"
      },
      text: {
        type: String,
        default: "Loading..."
      }
  }
}
</script>

<style scoped>
  div.block-ui {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    width: 100%;
    z-index: 900;
    background-color: rgba(0, 0, 0, 0.15);
  }

  div.block-ui .loading-spinner {
    width: 180px;
    height: 190px;
    border-radius: 10px;
    border: 2px solid rgba(0, 0, 0, 0.1);
    background-color: rgba(255, 255, 255, 0.9);
  }

  div.block-ui .block-ui--loading-text {
    color:#6D7079;
  }
</style>